import { Box, Stack, Tooltip, Typography } from '@mui/material';
import { DISPLAY, MONO, scoreHex, tokens } from '../theme';

/**
 * Điểm SEO dạng "số + thanh + độ lệch", đúng như demo của BA.
 *
 * Vì sao không dùng chip màu như bản cũ: các trang thực tế đều rơi vào 60–75 nên
 * chip nào cũng cùng một màu cam — thứ nổi nhất trên trang lại không phân biệt
 * được gì. Thanh dài theo điểm cho phép so 65 với 72 bằng mắt, và số vẫn đọc
 * được khi người xem không phân biệt màu.
 */
/**
 * Thanh vẽ theo thang 40–100 chứ không phải 0–100.
 *
 * Điểm thật của các trang chỉ dao động trong khoảng 55–85, nếu vẽ theo thang đầy
 * thì 60 và 72 dài gần bằng nhau — thanh trở thành đồ trang trí. Cắt bỏ phần
 * dưới 40 (không trang nào rơi vào) để chênh lệch nhìn thấy được.
 */
const FLOOR = 40;
function barPercent(score: number): number {
  return Math.max(6, Math.min(100, ((score - FLOOR) / (100 - FLOOR)) * 100));
}

export function ScoreMeter({ score, prev }: { score: number | null; prev: number | null }) {
  if (score === null) {
    return (
      <Typography component="span" sx={{ fontSize: 13.5, color: 'text.disabled' }}>
        chưa quét
      </Typography>
    );
  }

  const color = scoreHex(score);
  const diff = prev === null ? null : score - prev;

  return (
    <Stack direction="row" alignItems="center" spacing={0.9}>
      <Box
        sx={{
          fontFamily: DISPLAY,
          fontWeight: 700,
          fontSize: 16.5,
          color,
          width: 26,
          textAlign: 'right',
          fontVariantNumeric: 'tabular-nums',
        }}
      >
        {score}
      </Box>
      <Tooltip title={`${score}/100 điểm`}>
        <Box sx={{ width: 48, height: 6, borderRadius: 999, bgcolor: tokens.line2, flex: 'none' }}>
          <Box
            sx={{
              width: `${barPercent(score)}%`,
              height: '100%',
              borderRadius: 999,
              bgcolor: color,
            }}
          />
        </Box>
      </Tooltip>
      {/* Ô độ lệch luôn chiếm chỗ, kể cả khi trống — nếu không, dòng có độ lệch
          sẽ rộng hơn dòng không có và cả cột trông so le. */}
      <Box sx={{ width: 30, fontFamily: MONO, fontSize: 12.5, fontWeight: 600, whiteSpace: 'nowrap' }}>
        {diff !== null && diff !== 0 && (
          <Tooltip title={`Lần quét trước: ${prev} điểm`}>
            <Box component="span" sx={{ color: diff > 0 ? tokens.okText : tokens.roseText }}>
              {diff > 0 ? `+${diff}` : diff}
            </Box>
          </Tooltip>
        )}
      </Box>
    </Stack>
  );
}
